export class GaiaCalendar {
    static DAYS_IN_MONTH = 32;
    static MONTHS_IN_YEAR = 12;
    static START_YEAR = 7; // εγλ 0007
  
    static formatGameDate(dayCount) {
      // Calculate years passed
      const daysInYear = this.DAYS_IN_MONTH * this.MONTHS_IN_YEAR;
      const yearsPassed = Math.floor((dayCount - 1) / daysInYear);
      const year = this.START_YEAR + yearsPassed;
      
      // Calculate remaining days
      const remainingDays = (dayCount - 1) % daysInYear;
      
      // Calculate month (1-based)
      const month = Math.floor(remainingDays / this.DAYS_IN_MONTH) + 1;
      
      // Calculate day of month (1-based)
      const day = (remainingDays % this.DAYS_IN_MONTH) + 1;
  
      // Format with leading zeros for day and month
      const formattedDay = day.toString().padStart(2, '0');
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedYear = year.toString().padStart(4, '0');
  
      return `${formattedDay}/${formattedMonth}/εγλ ${formattedYear}`;
    }
  }
  